<template>
	<FormGroup :state="dateValid" :invalid-feedback="dateError" feedback-beneath>
		<b-input
			v-model="dateString"
			placeholder="TT.MM.JJJJ (z.B. 19.11.1979)"
			@input="emitChangeEvent"
		/>
	</FormGroup>
</template>
<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import {DateTime} from "luxon";
import FormGroup from "@/vue/common/form/Group";
import {formatDate} from "@/helper/Date";

export default {

	components: {
		FormGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		let dateString = '';

		if (this.value)
		{
			dateString = formatDate(
				DateTime.fromObject(this.value)
			);
		}

		return {
			dateString
		}
	},

	computed: {
		date ()
		{
			const dateTime = DateTime.fromFormat(this.dateString, 'dd.LL.y');

			if (!dateTime || dateTime.invalid)
			{
				return null;
			}

			if (dateTime.year < 1900)
			{
				return null;
			}

			return {
				day: dateTime.day,
				month: dateTime.month,
				year: dateTime.year
			};
		},
		dateError ()
		{
			if (isEmptyOrNull(this.dateString))
			{
				return 'Bitte gib dein Geburtsdatum ein';
			}

			if (!this.date)
			{
				return 'Ungültiges Datum';
			}

			return null;
		},
		dateValid ()
		{
			return !isDefined(this.dateError);
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dateValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', this.date);
		}
	}
}
</script>
